module.exports = __webpack_public_path__ + "static/media/flutter.5c3a6308.svg";